export default __webpack_public_path__ + "static/media/index.16c7fd91.jpg";